import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/payments`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/payments/${id}`);
  },
  
  create(payment){
    return Http.post(`/payments`, {payment: {...payment}})
  },

  update(payment){
    return Http.put(`/payments/${payment.id}`, {
      payment: {...payment},
    });
  },

  delete(id){
    return Http.delete(`/payments/${id}`)
  },
  payment_resume_pdf(payment_id){
    return Http.get(`/payments/payment_resume_pdf`, {params: { payment_id }})
  },
  updateWithFormData(payment){
    return Http.put(`/payments/${payment.get('payment[id]')}`, payment);
  },

}
